import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button,
  TextField, Autocomplete, FormControl, CircularProgress, Box, Typography
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Stack from '@mui/material/Stack';
import { useParams } from 'react-router-dom';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import {
  GetApp as DownloadIcon,
  InsertDriveFile as CsvIcon,
  Description as ExcelIcon
} from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import CustomModal from '../../components/CustomModal';
import LabourBillCheckData from '../Masters/LabourBillCheckData';

function ReportData(props) {
  const { endpoint } = useParams();
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [showGrid, setShowGrid] = useState(true);
  const [itemCode, setItemCode] = useState('');
  const [itemName, setItemName] = useState('');
  const [subledgerCode, setSubLedgerCode] = useState('');
  const [serialNumber, setSerialNumber] = useState(1);

  const [reportData, setReportData] = useState([]);
  const [reportData1, setReportData1] = useState([]);
  const [opbal, setOpbal] = useState(0);
  const [balance, setBalance] = useState(0);
  const [balances, setBalances] = useState({});
  const [lastBalance, setLastBalance] = useState(0);

  const [itemMasterEntries, setItemMasterEntries] = useState([]);
  const [ProcessEntries, setProcessEntries] = useState([]);
  const [subledgerMaster, setSubledgerMaster] = useState([]);
  const [VehicleMasterEntries, setVehicleMasterEntries] = useState([]);
  const [ideptMasterEntries, setIDeptMasterEntries] = useState([]);
  const [compMasterEntries, setCompMasterEntries] = useState([]);

  const [exportFormat, setExportFormat] = useState(null);
  const [selectSubledger, setSelectSubledger] = useState(false);
  const [selectItem, setSelectItem] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showH1Component, setShowH1Component] = useState(false);

  const [fetchedData, setFetchedData] = useState([]);
  const [detailedData, setDetailedData] = useState(null);
  const [open, setOpen] = useState(false);
  const [initialData, setInitialData] = useState([]);

  const location = useLocation();
  const flag = new URLSearchParams(location.search).get('flag');
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setReportData([]);
    if (endpoint) {
      if (endpoint) {
        setSelectSubledger(true);
        setSelectItem(true);
      } else if (endpoint === 'BatchStock') {
        setSelectSubledger(false);
        setSelectItem(true);
      } else if (endpoint === 'stockStatement') {
        setSelectSubledger(false);
        setSelectItem(true);
      }
    }
    if (endpoint === 'stockLedgerr') {
      fetchReportData2();
      // console.log("stockledger");
    } else {
      fetchReportData();
    }
  }, [endpoint]);

  useEffect(() => {
    setSerialNumber(1);
  }, [endpoint]);

  useEffect(() => {
    if (showH1Component === true) {
      generatePDF();
      setTimeout(() => {
        setShowH1Component(false);
      }, 1000);
    }
  }, [showH1Component]);

  const incrementSerialNumber = () => {
    setSerialNumber(1);
  };

  useEffect(() => {
    incrementSerialNumber();
  }, []);

  useEffect(() => {
    fetchSubLedgerMaster();
    fetchItemMaster();
    fetchVehicleMaster();
    fetchCompMaster();
    fetchIDeptMaster();
  }, []);

  const fetchReportData = async (requestData) => {
    if (!requestData || !requestData.startDate || !requestData.endDate) {
      console.error('Error: Missing required parameters in requestData:', requestData);
      return;
    }

    try {
      setLoading(true);
      setProgress(30);

      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev < 80) return prev + 5;
          return prev;
        });
      }, 260);

      const response = await axios.get(`https://www.wingap.net.in/api/${endpoint}`, {
        params: requestData,
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            setProgress(Math.max(progress, percentCompleted));
          }
        },
      });
      setProgress(100);
      clearInterval(interval);
      setLoading(false);

      setReportData(response.data);
      setInitialData(response.data);
      //console.log("Report Data : ", response.data, endpoint);
    } catch (error) {
      console.log('error:', error);
    } finally {
      setLoading(false);
      incrementSerialNumber();
    }
  };

  const fetchReportData1 = async (requestData) => {
    try {
      setLoading(true);
      //console.log("endpoint :-", endpoint);

      const response = await axios.get(`https://www.wingap.net.in/api/${endpoint}`, { params: requestData });
      setReportData1(response.data);
      setInitialData(response.data);
      //console.log("Report Data 1: ", response.data);
    } catch (error) {
      console.log('error:', error);
    } finally {
      setLoading(false);
      incrementSerialNumber();
    }
  };

  const fetchReportData2 = async (requestData) => {
    if (!requestData || !requestData.startDate || !requestData.endDate || !requestData.itemCode) {
      console.error('Error: Missing required parameters in requestData:', requestData);
      return;
    }

    try {
      setLoading(true);
      setProgress(30);

      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev < 80) return prev + 5;
          return prev;
        });
      }, 260);

      const opBalFromReport = await handleStockReport();
      //console.log(requestData);
      const response = await axios.get(`https://www.wingap.net.in/api/${endpoint}`, { params: requestData });
      //console.log('Original Data:', response.data, opBalFromReport);
      if (response.data.length === 0) {
        setReportData([]);
        setOpbal('');
        setBalance('');
        return;
      }
      let ResponseData = response.data;

      let opbal = Number(opBalFromReport) || 0;
      let lastCurrentBalance = opbal;
      //console.log(opbal);
      const data = ResponseData.sort((a, b) => {
        const dateA = new Date(a.Trdate);
        const dateB = new Date(b.Trdate);

        if (dateA < dateB) return -1;
        if (dateA > dateB) return 1;

        if (a.EntryNo < b.EntryNo) return -1;
        if (a.EntryNo > b.EntryNo) return 1;

        return 0;
      }).map((rowData, index) => {
        const InQty = rowData.InQty || 0;
        const OutQty = rowData.OutQty || 0;

        const currentBalance = opbal + InQty - OutQty;
        lastCurrentBalance = currentBalance;
        const prevOpbal = opbal ? opbal : 0;
        opbal = currentBalance;

        return {
          ...rowData,
          OpQty: `${prevOpbal}`,
          BalQty: `${currentBalance}`,
        };
      });
      //console.log(data);
      if (data.length > 0) {
        setOpbal(data[data.length - 1].Balance);
        setBalance(data[data.length - 1].BalQty);
      } else {
        setOpbal('');
        setBalance('');
      }
      setProgress(100);
      clearInterval(interval);
      setLoading(false);

      setReportData(data);
      setInitialData(data);
      //console.log(lastCurrentBalance);
      setLastBalance(lastCurrentBalance);
    } catch (error) {
      console.log('error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStockReport = async () => {
    try {
      const uniqueDates = [startDate];
      const date = uniqueDates[0];
      //console.log(date, itemCode);

      const response = await axios.get('https://www.wingap.net.in/api/stockkReport', {
        params: {
          startDate: BeforeformatDate1(date),
          ItCode: parseInt(itemCode),
          CompCode: props.selectedCompany
        }
      });

      //console.log("Data", response.data);
      const balanceData = response.data.filter(item => item.ItCode == parseInt(itemCode))[0];
      const opBal = balanceData ? balanceData.BalQty : 0;
      console.log(balanceData);

      const balancesByDate = { [date]: { opBal } };

      setBalances(balancesByDate);
      return opBal;
    } catch (error) {
      console.error('Error fetching balances:', error);
    }
  };

  const handleSubLedgerChange = (value) => {
    setSubLedgerCode(value);
  };

  const handleItemChange = (value, type) => {
    if (type === 'code') {
      // If user enters ItCode manually
      setItemCode(value);
      const selectedItem = itemMasterEntries.find((item) => item.ItCode === value);
      setItemName(selectedItem ? selectedItem.ItName : '');
    } else if (type === 'name') {
      // If user selects ItName from dropdown
      setItemCode(value ? value.ItCode : '');
      setItemName(value ? value.ItName : '');
    }
  };
  

  const handleReset = () => {
    setSubLedgerCode('');
    setItemCode('');
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const fetchCompMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/company');
      setCompMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchIDeptMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/internalDept');
      setIDeptMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchSubLedgerMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/subledgerMaster');
      setSubledgerMaster(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };


  const fetchItemMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/items-master');
      setItemMasterEntries(response.data.sort((a, b) => a.ItCode - b.ItCode));
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchProcessEntries = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/processentry');
      const processEntries = response.data.reduce((acc, entry) => {
        acc[entry.EntryNo] = entry.DCNo;
        return acc;
      }, {});
      setProcessEntries(processEntries);
      //console.log(processEntries);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchVehicleMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/vehicle');
      setVehicleMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const handleSetParams = () => {
    const startDateFormatted = new Date(startDate).toISOString();
    const endDateFormatted = new Date(endDate).toISOString();

    const requestData = {
      USERID: props.name,
      DeptCode: props.selectedDept,
      YearCode: props.selectedYear,
      CompCode: props.selectedCompany,
      startDate: startDateFormatted,
      endDate: endDateFormatted,
      flag: flag ? `${flag}` : '',
    };

    if (selectSubledger && subledgerCode) {
      requestData.subledgerCode = parseInt(subledgerCode);
    }

    if (selectItem && itemCode) {
      requestData.itemCode = parseInt(itemCode);
    }

    if (selectSubledger && selectItem && subledgerCode && itemCode) {
      if (selectSubledger && subledgerCode) {
        //console.log("subledgercode: ", subledgerCode);

        if (endpoint === 'TonnageReport' || endpoint === 'PendingPurchaseOrderRegister') {
          const subachead = subledgerMaster.find(entry => entry.SubAcCode === subledgerCode)?.SubAcHead || null;
          requestData.subachead = subachead;
        } else {
          requestData.subledgerCode = parseInt(subledgerCode);
        }
      }
      requestData.itemCode = parseInt(itemCode);
    }

    if (endpoint === 'stockLedgerr') {
      fetchReportData2(requestData);
    } else {
      fetchReportData(requestData);
    }
    // console.log("Param Data", requestData);
  };

  const BeforeformatDate1 = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() - 1);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getCompanyName = (compCode) => {
    const company = compMasterEntries.find((entry) => entry.CompCode === compCode);
    return company ? company.CompName : '';
  };

  // Function to get SubAcHead based on SubAccode
  const getSubAcHead = (subAccode) => {
    const subledger = subledgerMaster.find((entry) => entry.SubAcCode == subAccode);
    return subledger ? subledger.SubAcHeadEng : '';
  };

  // Function to get ItName and PartNo based on ItCode
  const getItInfo = (itCode) => {
    const item = itemMasterEntries.find((entry) => entry.ItCode === itCode);
    return item ? { ItName: item.ItName } : { ItName: '' };
  };

  const getItRate = (itCode) => {
    const item = itemMasterEntries.find((entry) => entry.ItCode === itCode);
    return item ? item.CostRate : '';
  };

  const getItName = (itCode) => {
    const item = itemMasterEntries.find((entry) => entry.ItCode === itCode);
    return item ? item.ItName : '';
  };

  const getVehicleName = (vehicleCode) => {
    const vehicle = VehicleMasterEntries.find((entry) => entry.VehicleCode == vehicleCode);
    return vehicle ? vehicle.VehicleNo : '';
  };

  const getiDeptName = (vehicleCode) => {
    const vehicle = ideptMasterEntries.find((entry) => entry.IDeptCode == vehicleCode);
    return vehicle ? vehicle.IDeptName : '';
  };

  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }


  const csvContent = (data, headers, companyName, dateRange) => {
    const additionalInfo = [
      ['Company Name:', companyName],
      ['Date Range:', dateRange],
      [],
    ];
    const content = additionalInfo.concat([headers.join(',')]);

    data.forEach(rowData => {
      let clQtyValue = 0;
      const rowValues = headers.map(header => {
        if (header.toLowerCase().includes('date')) {
          return new Intl.DateTimeFormat('en-GB').format(new Date(rowData[header]));
        } else if (header === 'SubAccode' || header === 'subaccode') {
          return getSubAcHead(rowData[header]);
        } else if (header === 'ItCode' || header === 'itcode' || header === 'Itcode') {
          const { ItName } = getItInfo(rowData[header]);
          return `${ItName}`;
        } else if (header === 'VehicleCode') {
          return getVehicleName(rowData[header]);
        } else if (header === 'StockBal') {
          const balQty = Math.abs(rowData['BalQty'] || 0);
          const sentQty = Math.abs(rowData['SentQty'] || 0);
          const recdQty = Math.abs(rowData['RecdQty'] || 0);
          const stockBal = balQty + sentQty - recdQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'Cl.Qty') {
          const opqty = Math.abs(rowData['OpQty'] || 0);
          const prodQty = Math.abs(rowData['ProdQty'] || 0);
          const salesQty = Math.abs(rowData['SalesQty'] || 0);
          const rejQty = Math.abs(rowData['TotREJ'] || 0);
          const stockBal = opqty + prodQty - salesQty - rejQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'Amount') {
          const qty = Math.abs(rowData['Qty'] || 0);
          const rate = Math.abs(rowData['Rate'] || 0);
          const stockBal = qty * rate;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'InHouse_Cast') {
          const opqty = Math.abs(rowData['OpQty'] || 0);
          const prodQty = Math.abs(rowData['ProdQty'] || 0);
          const sentQty = Math.abs(rowData['SentQty'] || 0);
          const rejQty = Math.abs(rowData['TotREJ'] || 0);
          const stockBal = opqty + prodQty - sentQty - rejQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'InHouse_M/c') {
          const recdQty = Math.abs(rowData['RecdQty'] || 0);
          const salesQty = Math.abs(rowData['SalesQty'] || 0);
          const stockBal = recdQty - salesQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'At_m/cshop') {
          const recdQty = Math.abs(rowData['RecdQty'] || 0);
          const sentQty = Math.abs(rowData['SentQty'] || 0);
          const stockBal = sentQty - recdQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'TotalAmount') {
          const recdQty = clQtyValue;
          const sentQty = Math.abs(getItRate(rowData['Itcode']));
          const stockBal = sentQty * recdQty;
          return Math.abs(stockBal.toFixed(2));
        } else {
          return rowData[header];
        }
      });

      content.push(rowValues.join(','));
    });

    return content.join('\n');
  };

  const excelContent = (data, headers, companyName, dateRange) => {
    const additionalInfo = [
      ['Company Name:', companyName],
      ['Date Range:', dateRange],
      [],
    ];
    const transformedHeaders = headers.map(header => getCustomFieldName(header));
    const content = additionalInfo.concat([transformedHeaders.join(',')]);

    data.forEach(rowData => {
      let clQtyValue = 0;
      const rowValues = headers.map(header => {
        if (header.toLowerCase().includes('date')) {
          return new Intl.DateTimeFormat('en-GB').format(new Date(rowData[header]));
        } else if (header === 'SubAccode' || header === 'subaccode') {
          return getSubAcHead(rowData[header]);
        } else if (header === 'ItCode' || header === 'itcode' || header === 'Itcode') {
          const { ItName } = getItInfo(rowData[header]);
          return `${ItName}`;
        } else if (header === 'RawItCode') {
          const { ItName } = getItInfo(rowData[header]);
          return `${ItName}`;
        } else if (header === 'VehicleCode') {
          return getVehicleName(rowData[header]);
        } else if (header === 'StockBal') {
          const balQty = Math.abs(rowData['BalQty'] || 0);
          const sentQty = Math.abs(rowData['SentQty'] || 0);
          const recdQty = Math.abs(rowData['RecdQty'] || 0);
          const stockBal = balQty + sentQty - recdQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'Cl.Qty') {
          const opqty = Math.abs(rowData['OpQty'] || 0);
          const prodQty = Math.abs(rowData['ProdQty'] || 0);
          const salesQty = Math.abs(rowData['SalesQty'] || 0);
          const rejQty = Math.abs(rowData['TotREJ'] || 0);
          const stockBal = opqty + prodQty - salesQty - rejQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'Amount') {
          const qty = Math.abs(rowData['Qty'] || 0);
          const rate = Math.abs(rowData['Rate'] || 0);
          const stockBal = qty * rate;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'InHouse_Cast') {
          const opqty = Math.abs(rowData['OpQty'] || 0);
          const prodQty = Math.abs(rowData['ProdQty'] || 0);
          const sentQty = Math.abs(rowData['SentQty'] || 0);
          const rejQty = Math.abs(rowData['TotREJ'] || 0);
          const stockBal = opqty + prodQty - sentQty - rejQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'InHouse_M/c') {
          const recdQty = Math.abs(rowData['RecdQty'] || 0);
          const salesQty = Math.abs(rowData['SalesQty'] || 0);
          const stockBal = recdQty - salesQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'At_m/cshop') {
          const recdQty = Math.abs(rowData['RecdQty'] || 0);
          const sentQty = Math.abs(rowData['SentQty'] || 0);
          const stockBal = sentQty - recdQty;
          return Math.abs(stockBal.toFixed(2));
        } else if (header === 'TotalAmount') {
          const recdQty = clQtyValue;
          const sentQty = Math.abs(getItRate(rowData['Itcode']));
          const stockBal = sentQty * recdQty;
          return Math.abs(stockBal.toFixed(2));
        } else {
          return rowData[header];
        }
      });
      content.push(rowValues.join(','));
    });

    return content.join('\n');
  };

  const handleExport = async (format) => {
    setExportFormat(format);

    if (format === 'pdf') {
      generatePDF();
    } else if (format === 'csv') {
      const dataToExport = endpoint === 'PartyStockLedger' ? reportData1 : reportData;

      if (!dataToExport || dataToExport.length === 0) {
        console.error('No data available for export');
        return;
      }

      const csvContentData = csvContent(dataToExport, endpointFields[endpoint], getCompanyName(props.selectedCompany), `${startDate} to ${endDate}`);

      const blob = new Blob([csvContentData], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'Report_Data.csv');
    } else if (format === 'excel') {
      const dataToExport = endpoint === 'PartyStockLedger' ? reportData1 : reportData;

      if (!dataToExport || dataToExport.length === 0) {
        console.error('No data available for export');
        return;
      }

      const excelContentData = excelContent(dataToExport, endpointFields[endpoint], getCompanyName(props.selectedCompany), `${startDate} to ${endDate}`);

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('Report Data');

      const rows = excelContentData.split('\n');
      rows.forEach(row => {
        sheet.addRow(row.split(','));
      });

      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Report_Data.xlsx');
      });
    }

  };

  function keyIncludesDate(key) {
    return key.toLowerCase().includes('date');
  }

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: `${endpoint}`,
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  const calculateColumnSum = (fieldName, endpoint) => {
    const data = endpoint === 'PartyStockLedger' ? reportData1 : reportData;
    //console.log("endpoint :", endpoint, data);

    // Check if the field should be excluded from the sum
    if (excludeFromSum(fieldName)) {
      return '';
    }

    // Function to calculate closing quantity
    const calculateClQty = (rowData) => {
      const opQty = rowData['OpQty'] != null ? Math.abs(parseFloat(rowData['OpQty'])) : 0;
      const prodQty = rowData['ProdQty'] != null ? Math.abs(parseFloat(rowData['ProdQty'])) : 0;
      const salesQty = rowData['SalesQty'] != null ? Math.abs(parseFloat(rowData['SalesQty'])) : 0;
      const rejQty = rowData['TotREJ'] != null ? Math.abs(parseFloat(rowData['TotREJ'])) : 0;
      return opQty + prodQty - salesQty - rejQty;
    };

    // Handling 'StockBal' field
    if (fieldName === 'StockBal') {
      const stockBalSum = data.reduce((accumulator, rowData) => {
        const balQty = rowData['BalQty'] != null ? Math.abs(parseFloat(rowData['BalQty'])) : 0;
        const sentQty = rowData['SentQty'] != null ? Math.abs(parseFloat(rowData['SentQty'])) : 0;
        const recdQty = rowData['RecdQty'] != null ? Math.abs(parseFloat(rowData['RecdQty'])) : 0;
        return accumulator + (balQty + sentQty - recdQty);
      }, 0);
      return stockBalSum.toFixed(2);
    }

    // Handling 'Amount' field
    if (fieldName === 'Amount') {
      const amtSum = data.reduce((accumulator, rowData) => {
        const qty = rowData['Qty'] != null ? Math.abs(parseFloat(rowData['Qty'])) : 0;
        const rate = rowData['Rate'] != null ? Math.abs(parseFloat(rowData['Rate'])) : 0;
        return accumulator + (qty * rate);
      }, 0);
      return amtSum.toFixed(2);
    }

    // Handling 'TotalAmount' field
    if (fieldName === 'TotalAmount') {
      const totalAmountSum = data.reduce((accumulator, rowData) => {
        const clQty = calculateClQty(rowData);
        const rate = getItRate(rowData['Itcode']) || 0; // Assuming `getItRate` is a function you have
        return accumulator + (clQty * rate);
      }, 0);
      return totalAmountSum.toFixed(2);
    }

    // Handling 'Qty' field
    if (fieldName === 'Qty') {
      const qtySum = data.reduce((accumulator, rowData) => {
        return accumulator + (rowData['Qty'] != null ? Math.abs(parseFloat(rowData['Qty'])) : 0);
      }, 0);
      return qtySum.toFixed(2);
    }

    // General case for any other fields
    const sum = data.reduce((accumulator, rowData) => {
      const fieldValue = rowData[fieldName] != null ? Math.abs(parseFloat(rowData[fieldName])) : 0;
      return accumulator + fieldValue;
    }, 0);

    return sum.toFixed(2);
  };


  /* const calculateColumnSum = (fieldName, endpoint) => {
    const data = endpoint === 'PartyStockLedger' ? reportData1 : reportData;
    console.log("endpoint :", endpoint, data);
    if (excludeFromSum(fieldName)) {
      return '';
    }
  
    const calculateClQty = (rowData) => {
      const opQty = Math.abs(isNaN(rowData['OpQty']) ? 0 : parseFloat(rowData['OpQty']));
      const prodQty = Math.abs(isNaN(rowData['ProdQty']) ? 0 : parseFloat(rowData['ProdQty']));
      const salesQty = Math.abs(isNaN(rowData['SalesQty']) ? 0 : parseFloat(rowData['SalesQty']));
      const rejQty = Math.abs(isNaN(rowData['TotREJ']) ? 0 : parseFloat(rowData['TotREJ']));
      const clQty = opQty + prodQty - salesQty - rejQty;
      return clQty;
    };
  
    if (fieldName === 'StockBal') {
      const stockBalSum = data.reduce((accumulator, rowData) => {
        const balQty = Math.abs(isNaN(rowData['BalQty']) ? 0 : parseFloat(rowData['BalQty']));
        const sentQty = Math.abs(isNaN(rowData['SentQty']) ? 0 : parseFloat(rowData['SentQty']));
        const recdQty = Math.abs(isNaN(rowData['RecdQty']) ? 0 : parseFloat(rowData['RecdQty']));
        const stockBal = balQty + sentQty - recdQty;
        return accumulator + stockBal;
      }, 0);
      return stockBalSum.toFixed(2);
    }
    else if (fieldName === 'Amount') {
      const amtSum = data.reduce((accumulator, rowData) => {
        const qty = Math.abs(isNaN(rowData['Qty']) ? 0 : parseFloat(rowData['Qty']));
        const rate = Math.abs(isNaN(rowData['Rate']) ? 0 : parseFloat(rowData['Rate']));
        const clQty = qty * rate;
        return accumulator + clQty;
      }, 0);
      return amtSum.toFixed(2);
    }
    else if (fieldName === 'TotalAmount') {
      const totalAmountSum = data.reduce((accumulator, rowData) => {
        const clQty = calculateClQty(rowData);
        const rate = Math.abs(getItRate(rowData['Itcode']));
        const totalAmount = clQty * rate;
        return accumulator + totalAmount;
      }, 0);
      return totalAmountSum.toFixed(2);
    }
    else if (fieldName === 'Qty') {
      const qtySum = data.reduce((accumulator, rowData) => {
        return accumulator + (isNaN(rowData['Qty']) ? 0 : Math.abs(parseFloat(rowData['Qty'])));
      }, 0);
      return qtySum;
    }
    else {
      const sum = data.reduce((accumulator, rowData) => {
        return accumulator + (isNaN(rowData[fieldName]) ? 0 : Math.abs(parseFloat(rowData[fieldName])));
      }, 0);
      return sum.toFixed(2);
    }
  }; */

  // Function to check if a column should be excluded from sum
  const excludeFromSum = (fieldName) => {
    const excludedColumns = ['Sr.No.', 'Flag', 'Entryno', 'PONo', 'Trdate', 'PODate', 'Subaccode', 'ItCode', 'Remark1',
      'GstRate', 'PartyName', 'GRNEntryNo', 'QcItCode', 'Narration1', 'Narration2', 'Manufacture', 'Expiry', 'QualityCheck', 'ItName', 'Amt', 'RawItCode', 'PerQty', 'ProdPlanEntryNo', 'BatchNo', 'deptcode', 'OpQty',
      'InQty', 'OutQty', 'Desc1', 'Desc2', 'BillNo', 'ProdBatchNo', 'Remark3', 'VehicleCode', 'GstAmt', 'Rate', 'ItemDesc', 'ItemSubGroupName', 'Opbal', 'PQty', 'SQty'];
    const lowerCaseFieldName = fieldName.toLowerCase();
    return excludedColumns.some(excludedColumn => excludedColumn.toLowerCase() === lowerCaseFieldName);
  };

  const generateCalculationRow = () => {
    return (
      <tr style={{ backgroundColor: '#f2f2f2', color: 'black', fontWeight: 'bold' }}>
        <td></td>
        {endpointFields[endpoint].map((field) => (
          <td
            key={field}
            style={{
              padding: '5px',
              background: '#f2f2f2',
              border: '1px solid #333', textAlign: 'right'
            }}
          >
            {/* {field.toLowerCase().includes('date') ? '' : calculateColumnSum(field, endpoint)} */}
            {(endpoint === 'stockLedgerr' && field.toLowerCase().includes('balqty')) ? (
              `${Math.abs(lastBalance).toFixed(2)}`
            ) : field.toLowerCase().includes('date') ? (
              ''
            ) : (
              calculateColumnSum(field, endpoint)
            )}
          </td>
        ))}
      </tr>
    );
  };

  //Table 
  const endpointFields = {
    PurchaseOrderRegister: ['EntryNo', 'TrDate', 'SubAccode', 'ItCode', 'ItemDesc', 'Qty', 'Weight', 'Rate', 'Amt', 'GstRate', 'GstAmt', 'NetAmt'],
    GRNRegister: ['EntryNo', 'TrDate', 'PONo', 'PODate', 'BillNo', 'BillDate', 'SubAccode', 'ItCode', 'ItemDesc', 'Qty', 'Rate', 'Amt', 'GstRate', 'GstAmt', 'NetAmt'],
    ProductionPlanRegister: ['EntryNo', 'TrDate', 'ItCode', 'PerQty', 'Remark1', 'RawItCode', 'Qty', 'Weight'],
    ProductionRegister: ['EntryNo', 'TrDate', 'ProdPlanEntryNo', 'ItCode', 'ProdBatchNo', 'PerQty', 'Rate', 'Amt', 'Remark1', 'RawItCode', 'BatchNo', 'Qty', 'Weight', 'Rate1', 'Amount1'],
    ConsumptionRegister: ['EntryNo', 'TrDate', 'PONo', 'PODate', 'BillNo', 'BillDate', 'SubAccode', 'ItCode', 'ItemDesc', 'Qty', 'Rate', 'Amt', 'GstRate', 'GstAmt', 'NetAmt'],
    DespatchRegister: ['EntryNo', 'TrDate', 'PONo', 'PODate', 'ItCode', 'ItemDesc', 'Qty', 'Weight', 'Rate', 'Amt', 'GstRate', 'GstAmt', 'NetAmt'],
    QualityCheckRegister: ['EntryNo', 'Flag', 'GRNEntryNo', 'TrDate', 'QCITCODE', 'Narration1', 'Narration2', 'Manufacture', 'Expiry', 'QualityCheck'],
    PackingRegister: ['EntryNo', 'TrDate', 'ItCode', 'PerQty', 'BatchNo', 'RawItCode', 'Qty', 'Weight'],
    stockLedgerr: ['Flag', 'EntryNo', 'TrDate', 'Billno', 'ItCode', 'Desc1', 'Desc2', 'deptcode', 'OpQty', 'InQty', 'OutQty', 'BalQty'],
    stockStatement: ['ItemSubGroupName', 'Itcode', 'Itname', 'Opbal', 'PQty', 'SQty', 'Balance'],
    BatchStock: ['ItCode', 'BatchNo', 'BalQty', 'BalWt'],
  };

  const generateTableHeaders = (fields, endpoint) => {
    return (
      <>
        {fields.map((field) => (
          <th
            key={field}
            style={{
              padding: '5px',
              background: '#f2f2f2',
              border: '1px solid #333',
            }}
          >
            {getCustomFieldName(field, endpoint) || ''}
          </th>
        ))}
        {endpoint === 'LabourBillCheck' && (
          <th
            style={{
              padding: '5px',
              background: '#f2f2f2',
              border: '1px solid #333',
            }}
          >
            Action
          </th>
        )}
      </>
    );
  };

  const fieldMappings = [
    { original: 'Remark1', custom: 'Narration' },
    { original: 'deptcode', custom: 'Internal Dept' },
    { original: 'SubAccode', custom: 'PartyName' },
    { original: 'subaccode', custom: 'PartyName' },
    { original: 'subachead', custom: 'PartyName' },
    { original: 'subAcHead', custom: 'PartyName' },
    { original: 'SubAcHead', custom: 'PartyName' },
    { original: 'ProdBatchNo', custom: 'Prod BatchNo' },
    { original: 'Itcode', custom: 'ItemName' },
    { original: 'ItCode', custom: 'Finished ItemName' },
    { original: 'ITCODE', custom: 'ItemName' },
    { original: 'VehicleCode', custom: 'VehicleNo' },
    { original: 'RawItCode', custom: 'Raw ItemName' },
    { original: 'entryno', custom: 'EntryNo' },
    { original: 'flag', custom: 'Flag' },
    { original: 'trdate', custom: 'TrDate' },
    { original: 'PQty', custom: 'InQty' },
    { original: 'SQty', custom: 'OutQty' },

  ];

  const applyEndpointMapping = (endpoint) => {
    const updatedMappings = fieldMappings.filter(mapping => mapping.original.toLowerCase() !== 'itcode');

    if (endpoint === 'ProductionPlanRegister' || endpoint === 'ProductionRegister') {
      updatedMappings.push({ original: 'ItCode', custom: 'FinishedItCode' });
      updatedMappings.push({ original: 'PerQty', custom: 'Total Prod' });
    } else if (endpoint === 'QualityCheckRegister') {
      updatedMappings.push({ original: 'QCITCODE', custom: 'Item Name' });
      updatedMappings.push({ original: 'Narration1', custom: 'Narrtion' });
      updatedMappings.push({ original: 'Narration2', custom: 'BatchNo' });
    } else if (!endpoint === 'stockStatement') {
      updatedMappings.push({ original: 'ItCode', custom: 'Item Name' });
    } else if (endpoint === 'BatchStock') {
      updatedMappings.push({ original: 'ItCode', custom: 'Item Name' });
      updatedMappings.push({ original: 'BalQty', custom: 'Total Qty' });
      updatedMappings.push({ original: 'BalWt', custom: 'Total Weight' });
    }

    return updatedMappings;
  };

  const getCustomFieldName = (originalField, endpoint) => {
    const updatedMappings = applyEndpointMapping(endpoint);
    const mapping = updatedMappings.find(mapping => mapping.original.toLowerCase() === originalField.toLowerCase());
    return mapping ? mapping.custom : originalField;
  };

  /* const generateTableRows = (rowData, fields, rowIndex, endpoint) => {
    const isProductionEndpoint = ['ProductionRegister', 'ProductionPlanRegister'].includes(endpoint);
    console.log(fields, rowIndex, endpoint);
    return (
      <>
        {fields.map((key, colIndex) => {
          const value = key.toLowerCase().includes('date') && rowData[key]
            ? (() => {
              const date = new Date(rowData[key]);
              const day = date.getDate().toString().padStart(2, '0');
              const month = (date.getMonth() + 1).toString().padStart(2, '0');
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            })()
            : key === 'SubAccode' || key === 'subaccode' ? getSubAcHead(rowData[key])
              : key === 'RawItCode' ? (
                <span>
                  {getItInfo(rowData[key]).ItName}
                </span>
              )
                : key === 'ItCode' ? (
                  <span>
                    {getItInfo(rowData[key]).ItName}
                  </span>
                )
                  : key === 'VehicleCode' ? getVehicleName(rowData[key])
                   : key === 'deptcode' ? getiDeptName(rowData[key])
                     : renderNumericCell(rowData[key]);
  
          const isNumeric = !isNaN(parseFloat(value)) && isFinite(value);
          const formattedValue =
            isNumeric &&
              key !== 'EntryNo' &&
              !(key.toLowerCase() === 'itcode' || key.toLowerCase() === 'perqty' || key.toLowerCase() === 'gstrate' || key.toLowerCase() === 'qty' || key.toLowerCase() === 'prodplanentryno')
              ? parseFloat(value).toFixed(2)
              : value;
  
          // Conditionally render based on rowIndex for production-related endpoints
          if (isProductionEndpoint && rowIndex > 0) {
            // Hide values for repeating columns in subsequent rows
            const repeatingFields = ['EntryNo', 'TrDate', 'ProdPlanEntryNo', 'ItCode', 'PerQty', 'Rate', 'Amt', 'BatchNo', 'Remark1'];
            if (repeatingFields.includes(key)) {
              return <td key={colIndex} style={{ padding: '4px', border: '1px solid #333' }}></td>;
            }
          }
  
          return (
            <td key={colIndex} style={{ padding: '4px', border: '1px solid #333', textAlign: isNumeric ? 'right' : 'left' }}>
              {formattedValue}
            </td>
          );
        })}
      </>
    );
  }; */

  const generateTableRows = (rowData, fields, rowIndex, endpoint, renderedGroups) => {
    const isProductionEndpoint = ['ProductionRegister', 'ProductionPlanRegister'].includes(endpoint);

    return (
      <>
        {fields.map((key, colIndex) => {
          const value = key.toLowerCase().includes('date') && rowData[key]
            ? (() => {
              const date = new Date(rowData[key]);
              const day = date.getDate().toString().padStart(2, '0');
              const month = (date.getMonth() + 1).toString().padStart(2, '0');
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            })()
            : key === 'QualityCheck'
              ? rowData[key] === 'P' ? 'Passed' : rowData[key] === 'F' ? 'Fail' : rowData[key]
              : key === 'SubAccode' || key === 'subaccode'
                ? (<span>{rowData[key]} - {getSubAcHead(rowData[key])}</span>)
                : key === 'RawItCode'
                  ? (<span>{rowData[key]} - {getItInfo(rowData[key]).ItName}</span>)
                  : key === 'ItCode'
                    ? (<span>{rowData[key]} - {getItInfo(rowData[key]).ItName}</span>)
                    : key === 'QCITCODE'
                      ? (<span>{rowData[key]} - {getItInfo(rowData[key]).ItName}</span>)
                      : key === 'VehicleCode'
                        ? getVehicleName(rowData[key])
                        : key === 'deptcode'
                          ? getiDeptName(rowData[key])
                          : renderNumericCell(rowData[key]);

          const isNumeric = !isNaN(parseFloat(value)) && isFinite(value);
          const formattedValue =
            isNumeric &&
              !['entryno', 'grnentryno', 'itcode', 'pono', 'batchno', 'billno', 'perqty', 'rate', 'amt', 'prodbatchno', 'prodplanentryno', 'remark1'].includes(key.toLowerCase())
              ? parseFloat(value).toFixed(2)
              : value;

          // Hide repeating fields for subsequent rows in the same group, only for production endpoints
          if (
            isProductionEndpoint &&
            ['EntryNo', 'TrDate', 'ProdPlanEntryNo', 'ItCode', 'PerQty', 'ProdBatchNo', 'Rate', 'Amt', 'Remark1'].includes(key) &&
            renderedGroups.has(`${key}-${rowData.EntryNo}`)
          ) {
            return <td key={colIndex} style={{ padding: '4px', border: '1px solid #333' }}></td>;
          }

          // Add the field to the rendered set
          if (
            isProductionEndpoint &&
            ['EntryNo', 'TrDate', 'ProdPlanEntryNo', 'ItCode', 'PerQty', 'ProdBatchNo', 'Rate', 'Amt', 'Remark1'].includes(key)
          ) {
            renderedGroups.add(`${key}-${rowData.EntryNo}`);
          }

          return (
            <td key={colIndex} style={{ padding: '4px', border: '1px solid #333', textAlign: isNumeric ? 'right' : 'left' }}>
              {formattedValue}
            </td>
          );
        })}
      </>
    );
  };

  const renderNumericCell = (value) => {
    if (typeof value === 'number') {
      return Math.abs(Math.round(value * 100) / 100);
    }
    return value;
  };

  const handleDetailed = async (rowData, startDate, endDate) => {
    const detailedData = { ...rowData, startDate, endDate };
    setDetailedData(detailedData);
    setOpen(true);
    await fetchDetailed(detailedData);
  };

  const fetchDetailed = async (detailedData) => {
    try {
      if (!detailedData || !detailedData.ProcessCode || !detailedData.Itcode || !detailedData.startDate || !detailedData.endDate) {
        return;
      }
      const response = await axios.get('https://www.wingap.net.in/api/LabourBillCheckDetailed', {
        params: {
          processCode: detailedData.ProcessCode,
          itemCode: detailedData.Itcode,
          startDate: detailedData.startDate,
          endDate: detailedData.endDate
        }
      });
      setFetchedData(response.data);
      //console.log("Details :- ", response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const getNormalizedAccode = (entry) => {
    return entry.SubAcCode || entry.subaccode || entry.SubAccode || entry.SUBACCODE || '';
  };

  const handleSearch = (searchQuery) => {
    if (!searchQuery) {

      setReportData(initialData);
      const lowercasedQuery = searchQuery.toLowerCase();
      const filtered = initialData.filter((entry) => {
        const partycode = getNormalizedAccode(entry);

        const partyNameEntry = subledgerMaster.find((partyEntry) => {
          const partyEntryCode = getNormalizedAccode(partyEntry);
          return partyEntryCode == partycode;
        });

        const partyName = partyNameEntry ? partyNameEntry.SubAcHead.toLowerCase() : '';
        return partyName.includes(lowercasedQuery);
      });
      setReportData(filtered);
    }
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
    //console.log('searchQuery', props.searchQuery);
  }, [props.searchQuery]);


  return (
    <div>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '72vh', color: 'white' }}>
          {/* <MulticolorCircularProgress style={{ color: '#2196f3' }} /> */}
          <Box
            sx={{
              position: "relative",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              height: "42vh",
            }}
          >
            <CircularProgress
              variant="determinate"
              value={progress}
              size={76}
              thickness={4}
              sx={{
                color: (theme) =>
                  theme.palette.mode === "light" ? "#2196f3" : "#90caf9",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                component="div"
                color="text.secondary"
                fontWeight="bold"
              >
                {`${progress}%`}
              </Typography>
            </Box>
          </Box>
        </div>
      ) : (
        <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
          <Stack direction="row" spacing={1} marginBottom={1}>
            <TextField
              type="date"
              label="Start Date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              type="date"
              label="End Date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />

            {selectSubledger && (
              <FormControl style={{ minWidth: '280px' }}>
                <Autocomplete
                  options={subledgerMaster}
                  getOptionLabel={(option) => option.SubAcHead || ''}
                  value={subledgerMaster.find((group) => group.SubAcCode === subledgerCode) || null}
                  onChange={(event, newValue) => handleSubLedgerChange(newValue ? newValue.SubAcCode : '')}
                  renderInput={(params) => <TextField {...params} label="Select Party" variant="outlined" />}
                />
              </FormControl>
            )}

              {selectItem && (
                <>
                  <Stack direction="row" spacing={1} marginBottom={1}>
                    {/* ItCode Field */}
                    <FormControl style={{ minWidth: '60px', maxWidth: '80px' }}>
                      <TextField
                        variant="outlined"
                        value={itemCode}
                        onChange={(e) => handleItemChange(e.target.value, 'code')}
                        placeholder="ItemCode"
                      />
                    </FormControl>

                    {/* ItName Dropdown */}
                    <FormControl style={{ minWidth: '320px' }}>
                      <Autocomplete
                        options={itemMasterEntries}
                        getOptionLabel={(option) => option.ItName || ''}
                        value={itemMasterEntries.find((group) => group.ItCode == itemCode) || null}
                        onChange={(event, newValue) => handleItemChange(newValue, 'name')}
                        renderInput={(params) => (
                          <TextField {...params} label="Select ItemName" variant="outlined" />
                        )}
                      />
                    </FormControl>
                  </Stack>
                </>
              )}

            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "yellow", color: "black", marginBottom: "8px", float: 'right', marginRight: "10px", '&:hover': {
                  color: 'white',
                },
              }}
              onClick={handleSetParams}
            >
              View Report
            </Button>
            <Button variant="contained" color="secondary" onClick={handleReset}>
              Reset
            </Button>
          </Stack>

          {showGrid && (
            <Grid item>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', marginTop: '10px' }}>
                <h1 style={{ fontSize: '20px', marginTop: '0', marginBottom: '0' }}>
                  {endpoint === 'PurchaseOrderRegister' && flag === 'POC'
                    ? 'Customer Purchase Order Register'
                    : (endpoint === 'PurchaseOrderRegister' && flag === 'POS')
                      ? 'Supplier Purchase Order Register'
                      : (endpoint === 'GRNRegister' && flag === 'GRN')
                        ? 'GRN Register'
                        : (endpoint === 'QualityCheckRegister' && flag === 'QUAL')
                          ? 'Quality Check Register'
                          : (endpoint === 'ProductionRegisterMonthwise')
                            ? 'Production Register Monthwise'
                            : (endpoint === 'ProductionPlanRegister' && flag === 'PRODPL')
                              ? 'Production Plan Register'
                              : (endpoint === 'ProductionRegister' && flag === 'PROD')
                                ? 'Production Register '
                                : (endpoint === 'ConsumptionRegister' && flag === 'CONS')
                                  ? 'Consumption Register'
                                  : (endpoint === 'PackingRegister' && flag == 'PACK')
                                    ? 'Packing Register'
                                    : (endpoint === 'DespatchRegister' && flag == 'DESP')
                                      ? 'Despatch Register'
                                      : (endpoint === 'MaterialRequestionRegister' && flag == 'MISSUE')
                                        ? 'Material Requestion Register'
                                        : (endpoint === 'stockLedgerr')
                                          ? 'Stock Ledger Report'
                                          : (endpoint === 'stockStatement')
                                            ? 'Stock Statement Report'
                                            : (endpoint === 'BatchStock')
                                              ? 'Batchwise Stock Report'
                                              : endpoint
                  }
                </h1>
                <div>
                  <Button
                    variant="contained"
                    onClick={() => setShowH1Component(true)}
                    sx={{ backgroundColor: 'red', color: 'white', marginLeft: '10px', '&:hover': { color: 'white' } }}
                    startIcon={<DownloadIcon />}
                  >
                    Download PDF
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleExport('csv')}
                    sx={{ backgroundColor: 'yellow', color: 'black', marginLeft: '10px', '&:hover': { color: 'white' } }}
                    startIcon={<CsvIcon />}
                  >
                    Export as CSV
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleExport('excel')}
                    sx={{ backgroundColor: 'green', color: 'white', marginLeft: '10px', '&:hover': { color: 'white' } }}
                    startIcon={<ExcelIcon />}
                  >
                    Export as Excel
                  </Button>
                </div>
              </div>
            </Grid>
          )}

          {showGrid && ((reportData && reportData.length > 0) || (reportData1 && reportData1.length > 0)) && (
            <div ref={componentPDF} style={{ width: '100%' }}>
              {showH1Component && (<h3>
                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                  <div style={{ fontSize: '18px' }}>{getCompanyName(props.selectedCompany)}</div>
                  <div style={{ fontSize: '14px' }}>Date :- From&nbsp;{`${startDate} to ${endDate}`}</div>
                  {subledgerCode && <div style={{ fontSize: '14px' }}>Ledger A/c: {getSubAcHead(subledgerCode)} </div>}
                  {itemCode && <div style={{ fontSize: '14px' }}>Item Name: {getItName(itemCode)} </div>}
                  <h1 style={{ fontSize: '18px', marginTop: '0' }}>
                    {endpoint === 'PurchaseOrderRegister' && flag === 'POC'
                      ? 'Customer Purchase Order Register'
                      : (endpoint === 'PurchaseOrderRegister' && flag === 'POS')
                        ? 'Supplier Purchase Order Register'
                        : (endpoint === 'GRNRegister' && flag === 'GRN')
                          ? 'GRN Register'
                          : (endpoint === 'QualityCheckRegister' && flag === 'QUAL')
                            ? 'Quality Check Register'
                            : (endpoint === 'ProductionRegisterMonthwise')
                              ? 'Production Register Monthwise'
                              : (endpoint === 'ProductionPlanRegister' && flag === 'PRODPL')
                                ? 'Production Plan Register'
                                : (endpoint === 'ProductionRegister' && flag === 'PROD')
                                  ? 'Production Register '
                                  : (endpoint === 'ConsumptionRegister' && flag === 'CONS')
                                    ? 'Consumption Register'
                                    : (endpoint === 'PackingRegister' && flag == 'PACK')
                                      ? 'Packing Register'
                                      : (endpoint === 'DespatchRegister' && flag == 'DESP')
                                        ? 'Despatch Register'
                                        : (endpoint === 'MaterialRequestionRegister' && flag == 'MISSUE')
                                          ? 'Material Requestion Register'
                                          : (endpoint === 'stockLedgerr')
                                            ? 'Stock Ledger Report'
                                            : (endpoint === 'stockStatement')
                                              ? 'Stock Statement Report'
                                              : (endpoint === 'BatchStock')
                                              ? 'Batchwise Stock Report'
                                              : endpoint
                    }
                  </h1>
                </div>
              </h3>)}

              <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #333' }}>
                <thead>
                  <tr style={{ background: '#f2f2f2', color: 'black' }}>
                    <th style={{ padding: '5px', background: '#f2f2f2', border: '1px solid #333', }}>Sr.No.</th>
                    {generateTableHeaders(endpointFields[endpoint], endpoint)}
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const renderedEntryNos = new Set();
                    return reportData
                      .sort((a, b) => {
                        const dateA = new Date(a.TrDate);
                        const dateB = new Date(b.TrDate);

                        if (dateA < dateB) return -1;
                        if (dateA > dateB) return 1;

                        if (a.EntryNo < b.EntryNo) return -1;
                        if (a.EntryNo > b.EntryNo) return 1;

                        return 0;
                      })
                      .map((rowData, index) => (
                        <React.Fragment key={index}>
                          <tr style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                            <td style={{ padding: '4px', border: '1px solid #333', textAlign: 'right' }}>{serialNumber + index}</td>
                            {generateTableRows(rowData, endpointFields[endpoint], index, endpoint, renderedEntryNos)}
                          </tr>
                          {index == (endpoint === "PartyStockLedger" ? reportData1.length - 1 : reportData.length - 1) &&
                            generateCalculationRow(endpoint === "PartyStockLedger" ? reportData1 : reportData)
                          }
                        </React.Fragment>
                      ));
                  })()}
                </tbody>
              </table>
              <CustomModal open={open} handleClose={handleCloseModal}>
                {fetchedData && <LabourBillCheckData fetchedData={fetchedData} />}
              </CustomModal>
            </div>
          )}

        </div>)}
    </div>
  );
}
export default ReportData;




























